import { Permission } from '@/features/shared/models/Permission';
import { Settings } from '@/features/shared/models/Settings';
import { defineStore } from 'pinia';
import { useBaseStore } from './baseStore';
import { container } from 'inversify-props';
import { ISettingsService, ISettingsServiceId } from '@/features/shared/ISettingsService';

export const useSettingsStore = defineStore('settings', {
    state: () => ({
        settings: null as Settings | null
    }),
    getters: {
        isReadOnly(state) {
            return state.settings.isReadOnly;
        },
        showMpcAvvik(state) {
            const permissions = state.settings.permissions;
            return permissions.includes(Permission.Avvik) && permissions.includes(Permission.Mpc);
        },
        showMpc(state) {
            return state.settings.permissions.includes(Permission.Mpc);
        },
        showAvvik(state) {
            return state.settings.permissions.includes(Permission.Avvik);
        },
        showMpcStatistics(state) {
            return state.settings.showMpcStatistics;
        }
    },
    actions: {
        async fetchSettings() {
            const baseStore = useBaseStore();
            const settingsService = container.get<ISettingsService>(ISettingsServiceId);

            try {
                baseStore.setIsLoading(true);

                this.settings = await settingsService.getSettings();

                baseStore.setIsLoading(false);
            } catch {
                baseStore.setIsLoading(false);
            }
        }
    }
});
